export default "__VITE_ASSET__fCxOgMNs__"